<template>
    <div class="show-os">
        <inline-svg
            v-if="os_icon !== 'empty'"
            :style="{fill: os_color}"
            :src="'/images/os/'+os_icon+'.svg'" aria-label="os">
        </inline-svg>
        <span v-else
              class="empty"
        ></span>
        {{os}}
    </div>
</template>
<script>
    export default {
        props: ['os'],
        computed: {
            os_color(){
                switch (this.os){
                    case 'Win10':       return '#2280fe';
                    case 'Android':     return 'green';
                    case 'iOS':         return '#333333';
                    case 'MacOSX':      return '#333333';
                    case 'macOS':       return '#333333';
                    case 'Win7':        return '#2280fe';
                    case 'Linux':       return 'orangered';
                    case 'Win8.1':      return '#2280fe';
                    case 'ChromeOS':    return 'unset';
                    case 'WinVista':    return '#2280fe';
                    case 'Win8':        return '#2280fe';
                    default:            return '#333333';
                }
            },
            os_icon(){
                switch (this.os){
                    case 'Win10':       return 'windows';
                    case 'Android':     return 'android';
                    case 'iOS':         return 'ios';
                    case 'MacOSX':      return 'ios';
                    case 'macOS':       return 'ios';
                    case 'Win7':        return 'windows';
                    case 'Linux':       return 'linux';
                    case 'Win8.1':      return 'windows';
                    case 'ChromeOS':    return 'chrome';
                    case 'WinVista':    return 'windows';
                    case 'Win8':        return 'windows';
                    default:            return 'empty';
                }
            }
        }
    }
</script>
